<template>
    <div v-if="counts.length > 0" class="chart" :class="{open: settingsOpen}">
        <canvas :id="ident" :ref="ident"></canvas>
    </div>
</template>

<script>
import axios from 'axios';
import Chart from 'chart.js';
import moment from 'moment';
import annotation from 'chartjs-plugin-annotation';

export default {
  name: 'StoreItemOccupancyHistory',
  props: {
    id: {type: Number, required: true},
    limit: {type: Number, required: true, default: 10},
    open: {}
  },
  data() {
    return {
      ident: `history-chart-${this.id}`,

      // Counts
      counts: [],
      lastFetchStamp: undefined,
      fetchInterval: undefined,
      chart: undefined,
      dataset: undefined,
      settingsOpen: false
    };
  },
  mounted() {
    this.fetchCounts();
        // Is updated every 1 minute, so only fetch every 1 minute.
    this.fetchInterval = setInterval(() => {
      this.fetchCounts();
    }, 60000);
  },


  watch: {
    open(newValue, oldValue) {

      this.settingsOpen = newValue;

      if (this.chart) {
        this.chart.resize();
      }

    }
  },

  methods: {
    fetchCounts() {

      axios.get(`${process.env.VUE_APP_API_BASE}/b/v1/intellicount/report/history/?site_id=${this.id}&api_key=${this.$store.getters.key}`)
        .then((res) => {

          if (res.status === 200) {
            this.counts = res.data.counts;
            setTimeout(() => {
              if (!this.chart) {
                this.prepareChart();
              } else {
                this.updateChart();
              }
            },10);

          } else {
            this.counts = [];
          }

        })
        .then(() => {
          this.$emit('updateOccupancy', this.counts.length);
        });

    },

    getDatasetData() {
      return this.counts.map((c) => {
        return {y: c.sum, x: moment(c.from).format('HH:mm')};
      });
    },

    updateChart() {
      this.dataset = this.getDatasetData();
      this.chart.data.datasets[0].data = this.dataset;
      this.chart.update();
    },

    prepareChart() {
      this.dataset = this.getDatasetData();

      this.chart = new Chart(this.$refs[this.ident], {
        type: 'line',
        data: {
          datasets: [{
            label: 'occupancy',
            data: this.dataset,
            backgroundColor: 'rgba(6, 132, 199,.25)',
            borderColor: 'rgb(6, 132, 199)',
            pointRadius: 0,
            lineTension: 0,
            borderWidth: 2,
          }]
        },
        options: {
          steppedLine: 'after',
          maintainAspectRatio: false,
          // responsive: false,
          legend: false,
          tooltips: {
            intersect: false,
          },
          scales: {
            xAxes: [{
              type: 'time',
              distribution: 'series',
              time: {
                parser: 'HH:mm',
                stepSize: .5,
                bounds: 'ticks',
                displayFormats: {
                  hour: 'HH:mm',
                  minute: 'HH:mm'
                }
              },
              ticks: {
                maxTicksLimit: 10,
              },
              gridLines: {
                color: 'rgba(0,0,0,0)'
              }
            }],
            yAxes: [{
              ticks: {
                suggestedMax: this.limit + 2,
                maxTicksLimit: 8,
                stepSize: 1,
                precision: 0,
              },
              gridLines: {
                color: 'rgba(0,0,0,0)'
              },
            }]
          },
          annotation: {
            drawTime: 'afterDatasetsDraw',
            annotations: [{
              type: 'line',
              id: 'vline0',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.limit,
              borderColor: 'red',
              borderWidth: 1,
              label: {
                enabled: true,
                position: 'left',
                content: 'limit',
                backgroundColor: 'rgba(255,255,255,0)',
                fontColor: '#E2574E',
                fontStyle: 'normal',
                yAdjust: -7
              },
            }, {
              type: 'line',
              id: 'vline1',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.limit / 100 * 90,
              borderColor: 'orange',
              borderWidth: 1,
              label: {
                enabled: true,
                position: 'left',
                content: '90%',
                backgroundColor: 'rgba(255,255,255,0)',
                fontColor: '#EFB06A',
                fontStyle: 'normal',
                yAdjust: 7
              },
            }]
          }
        }
      });

    }
  }
};
</script>

<style scoped lang="scss">
.chart {
    position: relative;
    background: #FFF;
    width: 100%;
    flex: 1;


    &:not(.open) {
        max-height: 152px;
    }

    &.open {
        padding: 1em;
        box-sizing: border-box;
        width: calc(100% - 2em);
        height: calc(100% - 2em);
        margin: 0 1em 1em;
        border-radius: .5em;
        box-shadow: var(--shadow);
    }
}
</style>